import React from "react";
import * as StorageService from "../../services/StorageService";
import {LOCALSTORAGE_ITEMS, ORDER_PLACE} from "../../util/Constants";

function OrderReviewActionsBar(props) {
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const hasGroupOrdering = shopDetails ? (typeof shopDetails.merchantConfig.groupOrders !== "undefined" ? shopDetails.merchantConfig.groupOrders : null) : false;
    const userType = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) : null;
    const orderPlace = StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_PLACE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_PLACE) : null;
    return (
        <div className={props.isVisible ? "actionsbar show" : "actionsbar"}>

            {props.extraHtml}
            {
                hasGroupOrdering && orderPlace === ORDER_PLACE.TABLE?

                    <div className="row buttons-row">
                        <a className={props.btnClassName} data-qa={props.dataQAIdentifier1} onClick={props.buttonAction}>
                            {props.buttonName}
                        </a>

                        <a data-qa={props.dataQAIdentifier2} className={props.btnClassName2} onClick={props.buttonAction2}>
                            {props.buttonName2}
                        </a>
                    </div>
                    :
                    <div className="row buttons-row">
                        <a  data-qa={props.dataQAIdentifier2}  className={props.btnClassName2}onClick={props.buttonAction2}>
                            {props.buttonName2}
                        </a>
                    </div>
            }
        </div>
    );
}

export default OrderReviewActionsBar;
